module.exports = __webpack_public_path__ + "static/media/demo.1c78463c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/_projects/rink-devtools/demo.mp4
// module id = 268
// module chunks = 0